import { language as lan_operation } from "./operation";
import { language as lan_list } from "./list";
import { language as lan_error } from "./error";

let language = {
    ...lan_operation,
    ...lan_list,
    ...lan_error
}

export { language }